import React, { useState, useEffect } from "react";
import { useAppContext } from "../libs/contextLib";
import { useHistory } from "react-router-dom";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Upgrade.css";

export default function Upgrade() {
    const { isAuthenticated, business } = useAppContext();
    const [isLoading, setIsLoading] = useState(true);
    const [copied, setCopied] = useState(false);
    const history = useHistory();
    const shareUrl = 'https://www.sertify.io';

    const shareFB = (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.FB.ui({
            method: 'share',
            href: shareUrl,
        }, function(response){});
    };

    useEffect(() => {
        async function onLoad() {
            if (!isAuthenticated) {
                return;
            }

            //if user is on premium plan, route them to /Home
            if (business.subscriptionType === 'premium') {
                history.push("home");
            }

            setIsLoading(false);
        }

        onLoad();
    }, [business, history, isAuthenticated]);

    function getMailToContent() {
        var content = "mailto:?subject=Check out Sertify!&body=Hi,%0D%0A%0D%0AI found this website and thought you might like it https://www.sertify.io%0D%0A%0D%0ACheers,%0D%0A" + business.ownerFirstName + " " + business.ownerLastName;
        return content;
    }

    function onCopy() {
        setCopied(true);
    };

    return (
        <div className="mainContent">
        <div className="content">
            {isAuthenticated && !isLoading && (
                <div className="upgrade">
                    <div className="contentHeader">
                        <h2>Thank you!</h2>
                    </div>
                    <div className="contentBody"> 
                        <div className="row-bottom-20"> 
                            Please let us know if you have any questions or suggestions - <a href="mailto:support@sertify.io">contact us</a>!
                        </div>
                        <div>
                            Share Sertify with your small business friends!
                        </div>
                    </div>
                    <div className="contentBody">
                        <Row>
                            <Col>
                                <a href="#" target="_blank" rel="noopener noreferrer" onClick={shareFB}>
                                    <FontAwesomeIcon icon={['fab', 'facebook']} size="3x"></FontAwesomeIcon>
                                </a>
                            </Col>
                            <Col>
                                <a href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=Welcome+to+Sertify&via=sertifysmall`} target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={['fab', 'twitter']} size="3x"></FontAwesomeIcon>
                                </a>
                            </Col>
                            {/* <Col>
                                <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={['fab', 'instagram']} size="3x"></FontAwesomeIcon>
                                </a>
                            </Col> */}
                            
                            <Col>
                                <a href={getMailToContent()} target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon="envelope" size="3x"></FontAwesomeIcon>
                                </a>
                            </Col>
                        </Row>
                    </div>
                    <div className="contentBody">
                        <div className="text-linkBtn">
                            <label>{copied ? "Copied" : "Click to Copy"}</label>
                            <CopyToClipboard
                                onCopy={onCopy}
                                text={"https://www.sertify.io"}>
                                <div className="pointer linkBtn-text">https://www.sertify.io</div>
                            </CopyToClipboard>
                        </div>
                    </div>
                </div>
            )}
        </div>
        </div>
    );
}